export default __webpack_public_path__ + "static/media/ethiopia.1b39957a.png";